module.exports = __webpack_public_path__ + "img/p8.00b89e7f.png";